module.exports = __webpack_public_path__ + "img/newletter-8.420a4b1.png";